import React, { ReactNode, useEffect, useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";

export default function NetworkStatus(props: { children: ReactNode }) {
  let [online, isOnline] = useState(navigator.onLine);

  const setOnline = () => {
    isOnline(true);
  };

  const setOffline = () => {
    isOnline(false);
  };

  useEffect(() => {
    // if user is offline -> call setOffline
    window.addEventListener("offline", setOffline);
    // if user is online -> call setOnline
    window.addEventListener("online", setOnline);

    return () => {
      window.removeEventListener("offline", setOffline);
      window.removeEventListener("online", setOnline);
    };
  }, []);

  return (
    <>
      {!online && <LinearProgress color="secondary" />}
      {/* <div style={{top:0, height: "10px", background: "red"}} /> */}
      {props.children}
    </>
  );
}
